export class CashDrawerStatuses {
    public static ACTIVE = 'ACTIVE';
    public static COMPLETE = 'COMPLETE';
    public static DELETED = 'DELETED';
}
